import type { UserGuidedTourType } from 'constants/user-guided-tour-type';

import { type IWithUserGuidedToursState } from './interfaces';

export const isTourReady = (state: IWithUserGuidedToursState, tourId: UserGuidedTourType): boolean => {
  return state.features.userGuidedTours.toursReady.includes(tourId);
};

export const isTourVisible = (state: IWithUserGuidedToursState, tourId: UserGuidedTourType): boolean => {
  return state.features.userGuidedTours.toursVisible.includes(tourId);
};

export const getTourStep = (state: IWithUserGuidedToursState, tourId: UserGuidedTourType): number => {
  return state.features.userGuidedTours.currentStep[tourId] ?? 0;
};

export const getTourStartStep = (state: IWithUserGuidedToursState, tourId: UserGuidedTourType): number => {
  return state.features.userGuidedTours.startStep[tourId] ?? 0;
};
